import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'helpers/no_conflict_lodash';

import { Table } from 'react-bootstrap';
import RecordRow from './record_row';

export class ScrollableRecordsTable extends React.Component {
  static propTypes = {
    currentStep: PropTypes.string.isRequired,
    headers: PropTypes.array.isRequired,
    recordIds: PropTypes.array.isRequired,
    records: PropTypes.object.isRequired
  }

  renderRecords() {
    const { recordIds, records } = this.props;
    return recordIds.map(id => <RecordRow key={id} record={records[id]}/>);
  }

  renderHeaders() {
    const { headers } = this.props;
    return headers.map(header => <th className="table-cell" key={header}>{_.startCase(header)}</th>);
  }

  render() {
    const { currentStep } = this.props;

    return (
      <div className="scrollable-table-container table-scroll-wrapper scroll-right-shadow scroll-left-shadow">
        <div className="table-scroll">
          <Table className="records-table mb-0">
            <thead className="records-header">
              <tr>
                {currentStep === "preview" && <th className="table-cell">Action</th>}
                {this.renderHeaders()}
              </tr>
            </thead>
            <tbody className="records-body">
              {this.renderRecords()}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.ui.currentStep,
  headers: state.runRecords.headers,
  records: state.runRecords.records,
  recordIds: state.runRecords.recordIds
});

export default connect(mapStateToProps)(ScrollableRecordsTable);
